import { apiSlice } from "features/api/apiSlice";

const getCallResponse = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getCallResponse: build.query({
      query: (id) => `appointments/oncall/status/${id}`,
      transformResponse: (res) => res.d.status,
    }),
  }),
});

export const { useGetCallResponseQuery } = getCallResponse;
